// import App from './App.svelte';
// import { mount } from "svelte";

// const app = mount(App, { target: document.getElementById("app") });

// export default app;
import { hydrate } from 'svelte'
import App from './App.svelte'

hydrate(App, {
    target: document.body,
});
